module.exports = __webpack_public_path__ + "img/1718178136940-IMG_6647.jpeg.27a20ac4.webp";